export default () => {
    const listeners = [];

    return {
        notify(...args) {
            listeners.forEach(listener => listener(...args));
        },
        subscribe(listener) {
            listeners.push(listener);
        },
    };
};
